<template>
  <div>
    <oe-access>
      <page-title>
        <template #pageTitleLeft>
          <h1 class="grape">
            Open Enrollment
          </h1>
        </template>
        <template #pageTitleRight>
          <div class="misc-buttons">
            <p class="_mb0 _mrxs">Need Help?</p>
            <router-link
              to="/contacts"
              tag="a"
              class="btn --sm white grape"
            >
              Contact Support
            </router-link>
          </div>
        </template>
      </page-title>
      <simple-copy :content="simpleCopyContent"/>
      <section>
        <div container>
          <div grid="row wrap">
            <h2 class="_mbs" v-if="$store.state.cloudCannon.cloudCannonContent.confirmationHeaderText">{{ $store.state.cloudCannon.cloudCannonContent.confirmationHeaderText }}</h2>
            <div v-if="component.selections" column="12">
              <p class="event-type"><strong>Request Type: </strong>
                <span
                  v-for="(type, i) in component.selections.eventTypes"
                  v-if="type.selected"
                  :key="i">
                <span>{{ type.nameShort }}</span>
              </span>
              </p>
            </div>

            <div
              v-if="component.selections && component.selections.location.locationName"
              column="3"
              class="_mtxs _mbxs"
            >
              <p class="_m0"><strong>Location Name: </strong></p>
              <p>{{ component.selections.location.locationName }}</p>
            </div>

            <div
              v-if="component.selections && component.selections.location.location.addressLine1"
              column="3"
              class="_mtxs _mbxs"
            >
              <p class="_m0"><strong>Address Line 1: </strong></p>
              <p>{{ component.selections.location.location.addressLine1 }}</p>
            </div>

            <div
              v-if="component.selections && component.selections.location.location.addressLine2"
              column="3"
              class="_mtxs _mbxs"
            >
              <p class="_m0"><strong>Address Line 2: </strong></p>
              <p>{{ component.selections.location.location.addressLine2 }}</p>
            </div>

            <div
              v-if="component.selections && component.selections.location.location.city"
              column="3"
              class="_mtxs _mbxs"
            >
              <p class="_m0"><strong>City: </strong></p>
              <p>{{ component.selections.location.location.city }}</p>
            </div>

            <div
              v-if="component.selections && component.selections.location.location.state"
              column="3"
              class="_mtxs _mbxs"
            >
              <p class="_m0"><strong>State: </strong></p>
              <p>{{ component.selections.location.location.state }}</p>
            </div>

            <div
              v-if="component.selections && component.selections.location.location.zipCode"
              column="3"
              class="_mtxs _mbxs"
            >
              <p class="_m0"><strong>Zip Code: </strong></p>
              <p>{{ component.selections.location.location.zipCode }}</p>
            </div>

            <div
              v-for="(event, i) in component.events"
              v-if="event.showOnSummary && formattedValue(event.content)"
              :key="i"
              column="3"
              class="_mtxs _mbxs"
            >
              <p class="_m0"><strong>{{ event.label }}: </strong></p>
              <p class="wrap-text">{{ formattedValue(event.content) }}</p>
            </div>
          </div>
        </div>

        <div
          v-for="(product, i) in component.products"
          :key="i"
        >
          <collapsible-section
            :collapsible="true"
            :collapsed="true"
            :is-sub-section="true"
            class="sub-section"
          >
            <template #headerText>
              <h4>Benefit Summary #{{ i + 1 }}: {{ product.classPlanId }}</h4>
            </template>
            <template #collapsibleSection>
              <product-table v-if="product" :items="product"/>
            </template>
          </collapsible-section>
        </div>

        <div container>
          <div
            grid="row wrap"
            class="_mts"
          >
            <div column="6 +4">
              <button class="btn white --sm _mrxs" @click.prevent="print">Print Request Details</button>
              <router-link :to="{ name: 'open-enrollment' }" class="btn white --sm" tag="button">
                Create Another Event
              </router-link>
            </div>
          </div>
        </div>
      </section>
    </oe-access>
  </div>
</template>

<script>
  import PageTitle from '@sections/PageTitle'
  import SimpleCopy from '@sections/SimpleCopy'
  import CollapsibleSection from '@sections/CollapsibleSection'
  import { tableContent } from '@/js/open-enrollment/oe-table-content'
  import { openEnrollmentEventSummaryFactory } from '@/factories/open-enrollment/event-summary.factory'
  import ProductTable from '@organisms/ProductTable'
  import { formatDate } from '@/utils'
  import moment from 'moment'
  import OeAccess from '../../components/atoms/OeAccess'

  export default {
    components: {
      OeAccess,
      PageTitle,
      SimpleCopy,
      CollapsibleSection,
      ProductTable
    },
    data() {
      return {
        component: {},
        tableContent,
        simpleCopyContent:
          `<h1>${this.$store.state.cloudCannon.cloudCannonContent.confirmationTitle}</h1>${this.$store.state.cloudCannon.cloudCannonContent.confirmationContent}`
      }
    },
    methods: {
      print() {
        window.print()
      },
      formattedValue(content) {
        const dateReg = /^\d{4}-\d{2}([./-])\d{2}$/
        const timeReg = /^\d{2}:\d{2}$/

        if (content === true || content === false) {
          return content ? 'Yes' : 'No'
        } else if (content && content.toString().match(dateReg)) {
          return formatDate(content)
        } else if (content && content.toString().match(timeReg)) {
          return moment(content, 'hh:mm').format('h:mm A')
        } else {
          return content
        }
      }
    },
    async mounted() {
      this.component = {
        events: await openEnrollmentEventSummaryFactory(this.$store.state.openEnrollment.userSelections),
        selections: this.$store.state.openEnrollment.userSelections,
        products: this.$store.state.openEnrollment.userSelections.benefits
      }
    }
  }
</script>

<style lang="scss" scoped>
  .misc-buttons {
    display: inline-flex;
    align-items: center;
  }

  .event-type span:not(:last-child) span::after {
    content: ", "
  }

  .wrap-text {
    word-break: break-all;
  }
</style>
